import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Layout from 'components/Layout';
import { Box, Grid, Paper, Button, Container, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import { Tab, Tabs, Editor, TabPanel } from 'components/UI';
import Loading from 'components/Loading';
import useStyles from './Configuration.styled';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@material-ui/core/styles';
import { configActions } from 'state/modules/config';

const Configuration = () => {
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [coreConfig, setCoreConfig] = useState(0);
  const [integrationsConfig, setIntegrations] = useState(0);
  const {
    settings: { core, integrations },
    loading,
  } = useSelector((state) => state.config || {});

  const handleChangeIndex = (index) => setValue(index);
  const handleChange = (event, newValue) => setValue(newValue);

  const handleJsonChange = (type, json) => {
    if (type === 'core') {
      setCoreConfig(json);
    } else {
      setIntegrations(json);
    }
  };

  const handleSubmit = (payload) => {
    dispatch(configActions.fetchUpdateConfigurations(payload));
  };

  useEffect(() => {
    if (core) {
      setCoreConfig(core);
    }
    if (integrations) {
      setIntegrations(integrations);
    }
  }, [core, integrations]);

  return (
    <Layout title={i18n.t('configuration.title')}>
      <Container className={classes.container}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              <Box fontWeight="fontWeightBold" fontSize={24} mt={2} mb={3}>
                {i18n.t('configuration.title')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3} className={classes.paper}>
              <Tabs value={value} onChange={handleChange} aria-label="styled tabs example">
                <Tab label={i18n.t('configuration.core')} />
                <Tab label={i18n.t('configuration.integrations')} />
              </Tabs>
              <Box className={classes.tabContent}>
                <SwipeableViews
                  index={value}
                  onChangeIndex={handleChangeIndex}
                  axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                >
                  <TabPanel value={value} index={0} dir={theme.direction}>
                    {coreConfig ? (
                      <>
                        <Editor
                          json={{ ...coreConfig }}
                          handleChange={(json) => handleJsonChange('core', json)}
                        />
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                          <Button
                            color="primary"
                            disabled={loading}
                            variant="contained"
                            onClick={() => {
                              const payload = { core: { ...coreConfig } };
                              handleSubmit(payload);
                            }}
                            style={{ textTransform: 'capitalize', minWidth: 130 }}
                          >
                            {i18n.t('common.submit')}
                          </Button>
                        </Box>
                      </>
                    ) : (
                      <Box
                        className={classes.loadingContainer}
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                      >
                        <Loading />
                      </Box>
                    )}
                  </TabPanel>
                  <TabPanel value={value} index={1} dir={theme.direction}>
                    {integrationsConfig ? (
                      <>
                        <Editor
                          json={{ ...integrationsConfig }}
                          handleChange={(json) => handleJsonChange('integrations', json)}
                        />
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                          <Button
                            color="primary"
                            disabled={loading}
                            variant="contained"
                            onClick={() => {
                              const payload = { integrations: { ...integrationsConfig } };
                              handleSubmit(payload);
                            }}
                            style={{ textTransform: 'capitalize', minWidth: 130 }}
                          >
                            {i18n.t('common.submit')}
                          </Button>
                        </Box>
                      </>
                    ) : (
                      <Box
                        className={classes.loadingContainer}
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                      >
                        <Loading />
                      </Box>
                    )}
                  </TabPanel>
                </SwipeableViews>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Configuration;
